// src/pages/products/CreateProduct/components/ImagesTab.jsx
import React from 'react';
import { Upload, X, Eye } from 'lucide-react';
import { useLocalization } from '../../../../contexts/LocalizationContext';
import styles from '../styles/ImagesTab.module.css';

const ImagesTab = ({
  images,
  mainImageIndex,
  onImageUpload,
  onImageRemove,
  onSetMainImage,
  onDragOver,
  maxImages = 5,
  onDrop,
  errors
}) => {
  const { t } = useLocalization();

  return (
    <div className={styles.formCard}>
      <div className={styles.cardHeader}>
        <h2>{t('products.productImages')}</h2>
        <p>{t('products.productImagesRecommendation')}</p>
      </div>
      <div className={styles.cardContent}>
        <div className={styles.imageUploadSection}>
          <div className={styles.imageUploadGrid}>
            {images.map((image, index) => (
              <div
                key={index}
                className={`${styles.imageUploadSlot} ${index === 0 ? styles.mainSlot : ''}`}
                onDragOver={onDragOver}
                onDrop={(e) => onDrop(e, index)}
              >
                {image ? (
                  <div className={styles.imagePreview}>
                    <img 
                      src={URL.createObjectURL(image)} 
                      alt={`Product ${index + 1}`} 
                      className={styles.previewImage} 
                    />
                    <div className={styles.imageActions}>
                      <button
                        type="button"
                        className={styles.removeImageButton}
                        onClick={() => onImageRemove(index)}
                      >
                        <X size={12} />
                      </button>
                      {index !== mainImageIndex && (
                        <button
                          type="button"
                          className={styles.setMainButton}
                          onClick={() => onSetMainImage(index)}
                          title={t('products.setAsMainImage')}
                        >
                          <Eye size={12} />
                        </button>
                      )}
                    </div>
                    {index === mainImageIndex && (
                      <div className={styles.mainImageBadge}>{t('products.mainImageBadge')}</div>
                    )}
                  </div>
                ) : (
                  <div className={styles.uploadPlaceholder}>
                    <input
                      type="file"
                      accept=".png,.jpg,.jpeg,.webp"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) onImageUpload(index, file);
                      }}
                      className={styles.imageInput}
                    />
                    <Upload size={20} className={styles.uploadIcon} />
                    <span className={styles.uploadText}>{t('products.uploadImages')}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className={styles.uploadInstructions}>
            <p>{t('products.dragDropInstructions')}</p>
            <p>{t('products.maxImagesNote', { max: maxImages })}</p>
          </div>
          {errors.images && <span className={styles.errorText}>{errors.images}</span>}
        </div>
      </div>
    </div>
  );
};

export default ImagesTab;